import { render, staticRenderFns } from "./RiepilogoAttivita.vue?vue&type=template&id=5a262f2a&"
import script from "./RiepilogoAttivita.vue?vue&type=script&lang=js&"
export * from "./RiepilogoAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports